// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JoinUsSection_wrapper__KRVM9","container":"JoinUsSection_container__MoD45","title":"JoinUsSection_title__cH8GL","subtitle":"JoinUsSection_subtitle__y56I7"};